import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as _ from 'lodash';

@Injectable()
export class TranslateService {
  constructor(
    private _http: HttpClient
  ) { }

  public onReady: EventEmitter<void> = new EventEmitter();
  public onUpdate: EventEmitter<void> = new EventEmitter();

  public ready = false;

  private _data: TranslateData;
  private _language: string;
  private _path: string;

  public async use(language: string, path?: string): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      this._language = language;
      this._path = path ? path : `/i18n/${this._language}.json`;

      if (this._restore()) {
        resolve(true);
        this.ready = true;
        this.onReady.emit();
        this._update();

      } else {
        const updated = await this._update();
        resolve(updated);
        this.ready = true;
        this.onReady.emit();
      }
    });
  }

  public get(path: string): string {
    const value = _.get(this._data, path);
    if (!value) { console.warn(`uexTranslate: Path \"${path}\" not found for language \"${this._language}\"`); }

    return value ? value.toString() : '';
  }

  private _save(): boolean {
    const key = this._getKey();

    try {
      const data = this._data ? this._data : {};
      localStorage.setItem(key, JSON.stringify(data));
      this.onUpdate.emit();

      return true;
    } catch (e) {
      console.warn(e);
    }

    this.onUpdate.emit();
    return false;
  }

  private _restore(): boolean {
    const key = this._getKey();

    try {
      const stored_data = localStorage.getItem(key);
      if (stored_data) {
        this._data = JSON.parse(stored_data);
        return true;
      }

    } catch (e) {
      console.warn(e);
    }

    this._data = {};
    return false;
  }

  private async _update(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this._http.get(this._path).toPromise()
        .then((response: TranslateData) => {
          if (_.isPlainObject(response)) {
            this._data = response;
            resolve(true);
          } else {
            this._data = {};
            resolve(false);
          }

          this._save();
        })
        .catch((err) => {
          console.warn(err);
          this._data = {};
          resolve(false);
          this._save();
        });
    });
  }

  private _getKey(): string {
    return this._language ? `uex-translate:${this._language}:data` : null;
  }
}

export interface TranslateData {
  [key: string]: string | TranslateData;
}
